import React, { useState } from 'react'

import {
  Button,
  Card,
  FavoriteOutlined,
  FileCopy,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, string } from 'prop-types'

import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

const favoriteIcon = <Icon svgComponent={FavoriteOutlined} size="small" />
const copyIcon = <Icon color="light" svgComponent={FileCopy} size="small" />

function CreditsArea({ copyText, buttonText, copyUrl, designerName, designerAvatarUrl = null }) {
  const [isCopied, setIsCopied] = useState(false)
  const showAvatar = Boolean(designerAvatarUrl)

  const handleCopyClick = () => {
    setIsCopied(true)
    const separator = copyUrl.includes('?') ? '&' : '?'
    navigator.clipboard.writeText(`${window.location.origin}${copyUrl}${separator}utm_source=credit_item_page`)
  }

  const titleElement = (
    <h6 className="credits-area__title">
      Give credit to <span className="credits-area__designer-name">{designerName}</span>
    </h6>
  )

  return (
    <div className="credits-area">
      <Card
        hasBorder
        isRounded
        icon={favoriteIcon}
        title={titleElement}
      >
        <span className="credits-area__text">{copyText}</span>

        <Button
          type="ghost"
          trailIcon={copyIcon}
          variant="with-icon"
          customClass="credits-area__button"
          onClick={handleCopyClick}
          aria-label={isCopied ? 'Link copied to clipboard' : `Copy link: ${buttonText}`}
        >
          {isCopied ? (
            <span role="status" aria-live="polite">
              Copied! Thank you for giving credit to the designer
            </span>
          ) : (
            <>
              {showAvatar && (
                <UserAvatar
                  img={designerAvatarUrl}
                  userName={designerName}
                  className="credits-area__avatar"
                  width="56"
                  height="48"
                />
              )}
              <span className="credits-area__button-text">{buttonText}</span>
            </>
          )}
        </Button>
      </Card>
    </div>
  )
}

CreditsArea.propTypes = {
  copyText: node.isRequired,
  buttonText: string.isRequired,
  copyUrl: string.isRequired,
  designerName: string.isRequired,
  designerAvatarUrl: string,
}

export default CreditsArea
